import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=95ca1a96&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=95ca1a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ca1a96",
  null
  
)

export default component.exports